// Lädt den Supabase-Client erst bei Bedarf (hält ihn aus dem kritischen Bundle heraus)
export const getSupabase = async () =>
  (await import("@/integrations/supabase/client")).supabase;
